import { colors } from 'fitify-ui/src/theme/colors'
import { Container } from 'fitify-ui-landing/src/components/Container/Container'
import { Typography } from 'fitify-ui-landing/src/components/Typography/Typography'
import { phone, tabletPortrait } from 'fitify-ui-landing/src/theme/breakpoints'
import { css, styled } from 'styled-components'

export const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  padding: 32px 32px 0;
  gap: 48px;
`

export const StyledSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const StyledExerciseList = styled.div`
  display: grid;
  overflow: hidden;
  gap: 16px;
  grid-template-columns: repeat(3, 1fr);

  ${tabletPortrait(css`
    gap: 12px;
    grid-template-columns: repeat(2, 1fr);
  `)};

  ${phone(css`
    grid-template-columns: 1fr;
  `)}
`

export const StyledSubtitle = styled(Typography)`
  max-width: 600px;
`

export const StyledResultCount = styled(Typography)<{ $isHidden?: boolean }>`
  color: ${colors.Gray600};
  visibility: ${({ $isHidden }) => ($isHidden ? 'hidden' : 'visible')};
`
